import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateDynamicPipe } from "../pipes/translate-dynamic.pipe";
import { ConvertLevelPipe } from "../pipes/convert-level.pipe";
import { ConvertDigLitSliderPipe } from "../pipes/convert-dl-slider.pipe";
import { ColorIndicatorPipe } from "../pipes/color-indicator.pipe";
import { ArraySortPipe } from "../pipes/array-sort.pipe";
import { WhiteSpaceDirective } from "./white-space.directive";
import { TruncateComponent } from "./components/truncate/truncate.component";
import { NonSpecialCharacterDirective } from "./non-special-character-directive";
import { ToUpperCasePipe } from "../pipes/to-uppercase.pipe";
import { SplitTranslationPipe } from "../pipes/split-translation.pipe";
import { CourseIconIdentifierPipe } from "../pipes/course-icon-identifier.pipe";
import { JoinArrayOfStringsPipe } from "../pipes/join-array-strings.pipe";
import { CustomExportService } from "./custom-export-service";
import { ReadOnlyWithClearDirective } from "./read-only-clear.directive";
import { AudioComponent } from "./components/audio/audio.component";
import { MaterialModule } from "./material.module";
import { NotificationIconPipe } from "../pipes/notification-icon.pipe";
import { DotLoaderComponent } from "./components/dot-loader/dot-loader.component";
import { ImportTranslatePipe } from "../pipes/import-error-message-pipe";
import { ResizableColumnDirective } from "./resizable-column.directive";
import { TimeStringPipe } from "../pipes/time-string.pipe";

@NgModule({
  declarations: [
    TranslateDynamicPipe,
    ConvertLevelPipe,
    ConvertDigLitSliderPipe,
    ColorIndicatorPipe,
    ArraySortPipe,
    WhiteSpaceDirective,
    TruncateComponent,
    NonSpecialCharacterDirective,
    ToUpperCasePipe,
    SplitTranslationPipe,
    CourseIconIdentifierPipe,
    JoinArrayOfStringsPipe,
    ReadOnlyWithClearDirective,
    AudioComponent,
    NotificationIconPipe,
    DotLoaderComponent,
    ImportTranslatePipe,
    ResizableColumnDirective,
    TimeStringPipe
  ],
  imports: [CommonModule, MaterialModule],
  exports: [
    TranslateDynamicPipe,
    ConvertLevelPipe,
    ConvertDigLitSliderPipe,
    ColorIndicatorPipe,
    ArraySortPipe,
    WhiteSpaceDirective,
    TruncateComponent,
    NonSpecialCharacterDirective,
    ToUpperCasePipe,
    SplitTranslationPipe,
    CourseIconIdentifierPipe,
    JoinArrayOfStringsPipe,
    ReadOnlyWithClearDirective,
    AudioComponent,
    NotificationIconPipe,
    DotLoaderComponent,
    ImportTranslatePipe,
    ResizableColumnDirective,
    TimeStringPipe
  ],
  providers: [
    TranslateDynamicPipe,
    ConvertLevelPipe,
    ConvertDigLitSliderPipe,
    ColorIndicatorPipe,
    ArraySortPipe,
    ToUpperCasePipe,
    SplitTranslationPipe,
    CourseIconIdentifierPipe,
    JoinArrayOfStringsPipe,
    CustomExportService,
    NotificationIconPipe,
    ImportTranslatePipe,
    ResizableColumnDirective,
    TimeStringPipe
  ],
})
export class SharedModule {}
